import { render, staticRenderFns } from "./MunicipioDescarregamento.vue?vue&type=template&id=1f7ad7f8"
import script from "./MunicipioDescarregamento.vue?vue&type=script&lang=js"
export * from "./MunicipioDescarregamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports